import {
  faBooks,
  faCalculator,
  faChevronLeft,
  faMagnifyingGlass,
} from '@fortawesome/sharp-solid-svg-icons';
import Fuse from 'fuse.js';
import { useEffect, useState } from 'react';
//import { CalculatedFieldRenderer } from "eone-help-renderer/calculated-field/calculated-field";
import { getJSON } from '@/functions/get-json';
import { Labels } from '@lib/sc-eone-ui/src/strings/strings-en-us';
import { HelpArticleRenderer } from 'eone-help-renderer/help-article/help-article-renderer';
import { Button } from 'eone-ui/buttons/button';
import { useHelpContext } from 'eone-ui/help-context';
import { InputString } from 'eone-ui/inputs/input-string';
import { RadioGroup } from 'eone-ui/radio/radio';
import { Sidebar } from 'eone-ui/sidebar/sidebar';
import './help-sidebar.css';

function HelpSearch(props) {
  const getSearchOptions = () => {
    return [
      {
        Value: 'all',
        Label: 'Everything',
      },
      {
        Value: 'help',
        Label: 'Help articles',
      },
      {
        Value: 'popdock-script',
        Label: 'Popdock script',
      },
    ];
  };

  const getContent = () => {
    if (
      (!props.ArticleResults || props.ArticleResults.length === 0) &&
      (!props.CalcFieldResults || props.CalcFieldResults.length === 0)
    ) {
      return <span className="eone-ui-modal-message">{'No results found'}</span>;
    }

    return (
      <div>
        {props.ArticleResults.map((result, index) => (
          <HelpArticleResults
            key={index}
            Type={'Article'}
            Name={result.Name}
            Slug={result.Slug}
            Children={result.Children}
          />
        ))}
        {props.CalcFieldResults.map((result, index) => (
          <HelpArticleResults
            key={index}
            Type={'Category'}
            Name={result.Name}
            Slug={result.Slug}
            Children={result.Functions}
          />
        ))}
      </div>
    );
  };

  if (!props.Visible) {
    return null;
  }

  return (
    <div className="pd-help-search-container">
      <div className="pd-help-search-string-container">
        <InputString
          Icon={faMagnifyingGlass}
          AutoFocus
          Placeholder={Labels.Search}
          Value={props.SearchValue}
          OnChange={props.ChangeSearchValue}
        />
        <RadioGroup
          Visible
          Buttons={getSearchOptions()}
          Value={props.SearchType}
          OnChange={props.ChangeSearchType}
        />
      </div>
      {getContent()}
    </div>
  );
}

function HelpArticleResults(props) {
  const helpContext = useHelpContext();

  return (
    <div style={{ margin: '1em' }}>
      <h1>
        <Button
          Label={props.Name}
          OnClick={() => helpContext.push({ Type: props.Type, Id: props.Slug })}
        />
      </h1>
      <div style={{ marginLeft: '1em' }}>
        {props.Children &&
          props.Children.map((article, index) => (
            <HelpArticleResults
              key={index}
              Name={article.Name}
              Type={props.Type === 'Category' ? 'Function' : props.Type}
              Slug={article.Slug}
              Children={article.Children}
            />
          ))}
      </div>
    </div>
  );
}

function Help(props) {
  const helpContext = useHelpContext();
  const [view, setView] = useState('documentation');
  const [article, setArticle] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [searchType, setSearchType] = useState('all');

  useEffect(() => {
    props.LoadHelp();
    props.LoadCalculatedFields();
  }, []);

  useEffect(() => {
    if (helpContext.top !== null) {
      switch (helpContext.top.Type) {
        case 'Article':
          getJSON(
            props.SettingsBaseUrl,
            'documentation',
            `help-articles/${helpContext.top.Id}.json`,
            loadArticle,
          );
          break;
        case 'Category':
        case 'Function':
          loadCalculatedField(helpContext.top.Type, helpContext.top.Id);
          break;
      }
      props.OpenHelpSidebar();
    } else {
      setArticle(null);
    }
  }, [helpContext.top]);

  const loadArticle = (articleJson) => {
    setArticle(articleJson);
    setView('documentation');
  };

  const findSelectedCalculatedField = (items, type, id) => {
    if (!type || !id) {
      return null;
    }
    for (let i = 0, len = items.length; i < len; i++) {
      if (type === 'Category' && items[i].Slug === id) {
        return items[i];
      } else if (type === 'Function' && items[i].Slug === id) {
        return items[i];
      }
      if (items[i].Functions) {
        const selectedCalculatedField = findSelectedCalculatedField(items[i].Functions, type, id);
        if (selectedCalculatedField) {
          return selectedCalculatedField;
        }
      }
    }
    return null;
  };

  const loadCalculatedField = (type, id) => {
    const newSelectedCalculatedFieldItem = findSelectedCalculatedField(
      props.CalculatedFields,
      type,
      id,
    );
    if (newSelectedCalculatedFieldItem) {
      newSelectedCalculatedFieldItem.Type = type;
      newSelectedCalculatedFieldItem.Id = id;
    }
    setArticle(newSelectedCalculatedFieldItem);
    setView('popdock-script');
  };

  const changeSelectedItem = (id, type) => {
    props.OpenHelpSidebar();
    helpContext.push({ Id: id, Type: type });
  };

  const showSearch = () => {
    setView('search');
  };

  const close = () => {
    helpContext.clear();
    props.OnClose();
  };

  const back = () => {
    const newTop = helpContext.pop();
    if (!newTop || !newTop.Id) {
      home();
    } else {
      switch (helpContext.top.Type) {
        case 'Article':
          getJSON(
            props.SettingsBaseUrl,
            'documentation',
            `help-articles/${newTop.Id}.json`,
            loadArticle,
          );
          break;
        case 'Category':
        case 'Function':
          loadCalculatedField(newTop.Type, newTop.Id);
          break;
      }
    }
  };

  const home = () => {
    setView('documentation');
    setArticle(null);
    helpContext.clear();
  };

  const popdockScriptHome = () => {
    setView('popdock-script');
    setArticle(null);
    helpContext.clear();
  };

  if (!props.IsOpen) {
    return null;
  }

  //const getHomePageArticles = () => {
  //    return props.Help.map(item => ({
  //        link: item.File,
  //        name: item.Name,
  //        pinToTop: item.PinToTop
  //    }));
  //};

  //const getCalculatedFieldCategories = () => {
  //    return props.CalculatedFields.map(calculatedField => ({
  //        type: "Category",
  //        id: calculatedField.Slug,
  //        name: calculatedField.Name,
  //        description: calculatedField.Description
  //    }));
  //};

  //const getCalculatedFieldFunctions = () => {
  //    if (!article || !article.Functions || article.Functions.length === 0) {
  //        return [];
  //    }

  //    let functions = [];
  //    for (let i = 0, len = article.Functions.length; i < len; i++) {
  //        functions.push({
  //            type: "Function",
  //            id: article.Functions[i].Slug,
  //            name: article.Functions[i].Name,
  //            description: article.Functions[i].Description
  //        });
  //    }
  //    return functions;
  //};

  //const getCalculatedFieldFunctionArguments = () => {
  //    if (!article || !article.Arguments || article.Arguments.length === 0) {
  //        return [];
  //    }

  //    let functionArguments = [];
  //    for (let i = 0, len = article.Arguments.length; i < len; i++) {
  //        functionArguments.push({
  //            name: article.Arguments[i].Name,
  //            description: article.Arguments[i].Description,
  //            fieldTypes: article.Arguments[i].FieldTypes,
  //            listItems: article.Arguments[i].ListItems,
  //            uiOnly: article.Arguments[i].UiOnly,
  //            isVariadic: article.Arguments[i].IsVariadic,
  //            optional: article.Arguments[i].Optional
  //        });
  //    }
  //    return functionArguments;
  //};

  //const getCalculatedFieldFunctionExamples = () => {
  //    if (!article || !article.Examples || article.Examples.length === 0) {
  //        return [];
  //    }

  //    let functionExamples = [];
  //    for (let i = 0, len = article.Examples.length; i < len; i++) {
  //        functionExamples.push({
  //            name: article.Examples[i].Name,
  //            description: article.Examples[i].Description,
  //            function: article.Examples[i].Function,
  //            result: article.Examples[i].Result
  //        });
  //    }
  //    return functionExamples;
  //};

  //const getCalculatedFieldFunctionRelated = () => {
  //    if (!article || !article.Related || article.Related.length === 0) {
  //        return [];
  //    }

  //    let functionRelated = [];
  //    for (let i = 0, len = article.Related.length; i < len; i++) {
  //        functionRelated.push({
  //            type: "Function", // todo - handle other types
  //            id: article.Related[i].RelatedResourceId,
  //            name: article.Related[i].Name
  //        });
  //    }
  //    return functionRelated;
  //};

  const fuseSearch = (data, search) => {
    const options = {
      isCaseSensitive: false,
      shouldSort: true,
      threshold: 0.25,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      findAllMatches: true,
      useExtendedSearch: true,
      keys: [
        { name: 'Name', weight: 0.8 },
        { name: 'Description', weight: 0.2 },
      ],
    };
    const fuse = new Fuse(data, options);

    const words = search.split(' ');
    const combinedResults = data.map((item) => ({ item, count: 0 }));

    words.forEach((word) => {
      const results = fuse.search(word);
      results.forEach((item) => {
        const index = combinedResults.findIndex(
          (combined) => combined.item.Slug === item.item.Slug,
        );
        if (index !== -1) {
          combinedResults[index].count++;
        }
      });
    });

    return combinedResults
      .filter((result) => result.count === words.length)
      .map((result) => result.item);
  };

  const getArticleSearchItems = (articles) => {
    const searchItems = [
      ...articles.map((article) => ({
        Slug: article.Slug,
        Name: article.Name,
      })),
      ...articles
        .filter((a) => a.Children && a.Children.length > 0)
        .flatMap((article) => getArticleSearchItems(article.Children)),
    ];
    return searchItems;
  };

  const getLeafArticlesWithSlugs = (articleItems, slugList) => {
    const leafArticles = [];
    for (const articleItem of articleItems) {
      if (articleItem.Children && articleItem.Children.length > 0) {
        leafArticles.push(...getLeafArticlesWithSlugs(articleItem.Children, slugList));
      } else if (slugList.includes(articleItem.Slug)) {
        leafArticles.push(articleItem);
      }
    }
    return leafArticles;
  };

  //const getArticlesWithSlugs = (articles, slugList) => {
  //    return articles.filter(article => slugList.includes(article.Slug) || (article.Children && article.Children.some(child => slugList.includes(child.Slug))))
  //        .map(article => ({
  //            ...article,
  //            Children: getArticlesWithSlugs(article.Children, slugList)
  //        }));
  //};

  const getCalculatedFieldSearchItems = () => {
    return props.CalculatedFields.flatMap((calc) => [
      {
        Slug: calc.Slug,
        Name: calc.Name,
        Description: calc.Description,
      },
      ...calc.Functions.map((func) => ({
        Slug: func.Slug,
        Name: func.Name,
        Description: func.Description,
      })),
    ]);
  };

  const getLeafCalculatedFieldsWithSlugs = (slugList) => {
    return props.CalculatedFields.flatMap((calcField) =>
      calcField.Functions.filter((calcFieldFunction) => slugList.includes(calcFieldFunction.Slug)),
    );
  };

  //const getCalculatedFieldsWithSlugs = (slugs) => {
  //    return props.CalculatedFields
  //        .filter(calc => slugs.includes(calc.Slug) || (calc.Functions && calc.Functions.some(func => slugs.includes(func.Slug))))
  //        .map(calc => ({
  //            ...calc,
  //            Functions: calc.Functions.filter(f => slugs.includes(f.Slug))
  //        }));
  //};

  const getCalculatedFieldSearchResults = () => {
    if (
      !searchValue ||
      searchValue.trim() === '' ||
      (searchType !== 'popdock-script' && searchType !== 'all')
    ) {
      return [];
    }
    const searchItems = getCalculatedFieldSearchItems();
    const foundSlugs = fuseSearch(searchItems, searchValue).map((s) => s.Slug);
    const results = getLeafCalculatedFieldsWithSlugs(foundSlugs);
    return results;
  };

  const getArticleSearchResults = () => {
    if (
      !searchValue ||
      searchValue.trim() === '' ||
      (searchType !== 'help' && searchType !== 'all')
    ) {
      return [];
    }
    const slugs = getArticleSearchItems(props.Help);

    const foundSlugs = fuseSearch(slugs, searchValue).map((s) => s.Slug);
    const results = getLeafArticlesWithSlugs(props.Help, foundSlugs);
    return results;
  };

  const getHeaderButtons = () => {
    return [
      {
        Title: 'Table of contents',
        Icon: faBooks,
        OnClick: home,
        DataTestId: 'helpHeader_home',
      },
      {
        Title: 'Popdock script reference',
        Icon: faCalculator,
        OnClick: popdockScriptHome,
        DataTestId: 'helpHeader_popdockScriptHome',
      },
      {
        Title: 'Search',
        Icon: faMagnifyingGlass,
        OnClick: showSearch,
        DataTestId: 'helpHeader_search',
      },
    ];
  };

  const getPreTitleButtons = () => {
    return [
      {
        Visible: article !== null,
        Title: Labels.GoBack,
        Icon: faChevronLeft,
        OnClick: back,
        DataTestId: 'helpHeader_back',
      },
    ];
  };

  return (
    <Sidebar
      HeaderTitle={Labels.Help}
      HeaderButtons={getHeaderButtons()}
      Close={close}
      PreTitleButtons={getPreTitleButtons()}
    >
      <HelpSearch
        Visible={view === 'search'}
        SearchType={searchType}
        SearchString={searchValue}
        ChangeSearchType={setSearchType}
        ChangeSearchValue={setSearchValue}
        ArticleResults={getArticleSearchResults()}
        CalcFieldResults={getCalculatedFieldSearchResults()}
      />
      <HelpArticleRenderer
        Visible={view === 'documentation' && article === null}
        Title={Labels.SmartConnectDocumentation}
        Description="Table of contents"
        Articles={props.Help}
        Theme="sidebar"
        SelectedItem={null}
        BaseUrl={props.SettingsBaseUrl}
        ChangeSelectedItem={changeSelectedItem}
      />
      <HelpArticleRenderer
        Visible={view === 'documentation' && article !== null}
        Name={article?.Title}
        SelectedItem={article}
        Description={article?.Description}
        Items={article?.Items}
        Articles={article?.Articles}
        RelatedArticles={article?.RelatedArticles}
        Theme="sidebar"
        BaseUrl={props.SettingsBaseUrl}
        ChangeSelectedItem={changeSelectedItem}
      />
      {/*<CalculatedFieldRenderer*/}
      {/*    Visible={view === "popdock-script" && article === null}*/}
      {/*    Name="Popdock script"*/}
      {/*    Categories={getCalculatedFieldCategories()}*/}
      {/*    Theme="sidebar"*/}
      {/*    OnClick={changeSelectedItem} />*/}
      {/*<CalculatedFieldRenderer*/}
      {/*    Visible={view === "popdock-script" && article !== null && article.Type === "Category"}*/}
      {/*    Name={article?.Name}*/}
      {/*    Description={article?.Description}*/}
      {/*    Functions={getCalculatedFieldFunctions()}*/}
      {/*    Theme="sidebar"*/}
      {/*    OnClick={changeSelectedItem} />*/}
      {/*<CalculatedFieldRenderer*/}
      {/*    Visible={view === "popdock-script" && article !== null && article.Type === "Function"}*/}
      {/*    Name={article?.Name}*/}
      {/*    Description={article?.Description}*/}
      {/*    Arguments={getCalculatedFieldFunctionArguments()}*/}
      {/*    Examples={getCalculatedFieldFunctionExamples()}*/}
      {/*    Related={getCalculatedFieldFunctionRelated()}*/}
      {/*    Theme="sidebar"*/}
      {/*    OnClick={changeSelectedItem} />*/}
    </Sidebar>
  );
}

export { Help };
